<div class="row d-flex justify-content-center">
  <div class="col-md-12 text-center pb-3">
    <img class="hiw-img" [width]="component.primary.icon.dimensions.width" [height]="component.primary.icon.dimensions.height" [alt]="component.primary.icon.alt" [src]="component.primary.icon.url" />
  </div>
</div>
